export const FRONT_LAYER_NAME = 'bringToFront';
export const BACK_LAYER_NAME = 'bringToBack';
